
export default (axios) => ({
	getCbsQueuesData(queryString) {
		return axios.get("/cbs_queues", {
			params: queryString
		})
	}
})